import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const CardisiographiePage = () => {
  return (
    <Layout>
      <PageHero
        title="3D-EKG (Cardisiographie)"
        subtitle="Moderne Herzdiagnostik zur erweiterten Beurteilung der Herzfunktion."
        backgroundImage="/images/EKG_neu.webp"
        ctaText="Untersuchung buchen"
      />

      <ContentSection
        title="Innovative EKG-Analyse"
        content="Die Cardisiographie ergänzt das klassische EKG und kann Hinweise auf Durchblutungsstörungen oder Belastungen des Herzens liefern. Die Untersuchung ist schnell, schmerzfrei und liefert aussagekräftige Ergebnisse."
        image="/images/EKG_neu.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Erweiterte Herzdiagnostik"
        content="Im Gegensatz zum klassischen Ruhe-EKG analysiert die Cardisiographie das Herz dreidimensional und kann so subtile Veränderungen erkennen, die bei herkömmlichen Methoden möglicherweise übersehen werden."
        image="/images/Kardiologie 2.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="3D-EKG Diez"
        content="Cardisiographie und moderne Herzdiagnostik im Medicum Diez – schonend, schnell und aussagekräftig für Patientinnen und Patienten im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Untersuchung vereinbaren"
        subtitle="Vereinbaren Sie Ihren Termin zur Cardisiographie online oder telefonisch."
        buttonText="Termin buchen"
      />
    </Layout>
  );
};


